import {initialServerState, initialUserState} from '../userInitialStates';
import {createAsyncThunk} from '@reduxjs/toolkit';
import ApiUtils from '../../../utils/apiUtils';
import base_url from '../../../baseUrls';


export const signOut = createAsyncThunk(
  'users/sign-out',
  async ( thunkAPI) => {
    try {
      const authToken = await ApiUtils.getAccessToken();
      if(!authToken) {
        return thunkAPI.rejectWithValue('AUTH_ERROR');
      }

      const response = await fetch(
        `${base_url.api}users/sign-out`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: authToken,
          },
        }
      );
      let data = await response.json();
      // console.log('getCurrentUserData response',response, response.status === 200);
      if (response.status === 200) {
        return {...data.data};
      } else {
        console.log('Rejected with', data);
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log('Error', e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const signOutReducer = {
  [signOut.fulfilled]: (state, {payload}) => {
    localStorage.clear();
    console.log('CLEAR LS');
    return {...initialServerState, ...initialUserState, ...{
      inviteLinkIsValid: false,
      isAuthenticated: false,
      isFetching: false,
    }};
  },
  [signOut.pending]: (state) => {
    state.isFetching = true;
  },
  [signOut.rejected]: (state) => {
    state.isFetching = false;
    state.isError = true;
  },
};
